import request from "./../../shared/request";

export async function readUserProfile() {
  const url = "/v1/api/getUserProfile";
  return request({ url, method: "GET" }).catch(() => {
    return undefined;
  });
}
